import { Fragment } from "react";
import { makeStyles } from "tss-react/mui";
import { formatDate, isRecentlyAdded } from "@miplatform/utils";
import { Box, Divider, Typography } from "@mui/material";

export function SectionInfo({ data }: ISectionInfoCardProps) {
  const { classes, theme } = useStyles();

  const isNew = isRecentlyAdded(data.createdOn);

  return (
    <Box className={classes.root}>
      <Box className={classes.configListCardText}>
        <Box className={classes.configListCardTextLine}>
          <Typography variant="HD2" color={theme.palette.primary.main}>
            {data.name}
          </Typography>
          {data.additionalTitleText?.map((text, index) => (
            <Fragment key={`${text}-${index}`}>
              <Divider orientation="vertical" />
              <Typography variant="BD2" color={theme.palette.text.secondary}>
                {text}
              </Typography>
            </Fragment>
          ))}
        </Box>
        <Box className={classes.configListCardTextLine}>
          {isNew && (
            <Box className={classes.newBadge}>
              <Typography variant="BD1">New</Typography>
            </Box>
          )}
          {data.modifiedOn && (
            <>
              <Typography variant="HD1">Last updated: </Typography>
              <Typography variant="HD1" fontWeight={400}>
                {formatDate(data.modifiedOn, "MMMM DD, YYYY")}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  configListCardContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  configListCardText: {
    display: "flex",
    flexDirection: "column",
  },
  configListCardTextLine: {
    height: 16,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  newBadge: {
    backgroundColor: theme.palette.warning.light,
    border: `1px solid ${theme.palette.warning.main}`,
    color: theme.palette.warning.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0, 0.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

interface ISectionInfoCardProps {
  data: {
    name: string;
    createdOn?: string;
    modifiedOn?: string;
    additionalTitleText?: string[];
  };
}
